import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { Environment, Float, MeshTransmissionMaterial, ContactShadows } from '@react-three/drei'
import * as THREE from 'three'

function Sphere() {
  const meshRef = useRef<THREE.Mesh>(null)
  const innerRef = useRef<THREE.Mesh>(null)

  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.y = state.clock.elapsedTime * 0.1
      meshRef.current.rotation.x = Math.sin(state.clock.elapsedTime * 0.5) * 0.1
    }
    if (innerRef.current) {
      innerRef.current.rotation.y = -state.clock.elapsedTime * 0.15
      innerRef.current.rotation.z = state.clock.elapsedTime * 0.1
    }
  })

  return (
    <Float speed={1.5} rotationIntensity={0.3} floatIntensity={0.5}>
      <group>
        {/* Outer Glass Sphere */}
        <mesh ref={meshRef} scale={1.5}>
          <sphereGeometry args={[1, 64, 64]} />
          <MeshTransmissionMaterial
            backside
            samples={4}
            thickness={0.5}
            chromaticAberration={0.15}
            anisotropy={0.1}
            distortion={0.1}
            distortionScale={0.5}
            temporalDistortion={0.1}
            transmission={1}
            roughness={0.05}
            ior={1.5}
            color="#ffffff"
            attenuationColor="#4fd8ff"
            attenuationDistance={2}
          />
        </mesh>
        
        {/* Inner Core */}
        <mesh ref={innerRef} scale={0.6}>
          <icosahedronGeometry args={[1, 2]} />
          <meshStandardMaterial
            color="#5ed29c"
            emissive="#5ed29c"
            emissiveIntensity={0.5}
            roughness={0.2}
            metalness={0.8}
          />
        </mesh>
        
        {/* Orbiting Rings */}
        {[0, 1, 2].map((i) => (
          <mesh key={i} rotation={[Math.PI / 2, 0, (i * Math.PI) / 3]}>
            <torusGeometry args={[1.8 + i * 0.3, 0.02, 16, 100]} />
            <meshBasicMaterial 
              color={i === 0 ? '#5ed29c' : i === 1 ? '#4fd8ff' : '#8b5cf6'} 
              transparent 
              opacity={0.4}
            />
          </mesh>
        ))}
      </group>
    </Float>
  )
}

export function GlassSphere() {
  return (
    <div className="w-full h-full">
      <Canvas camera={{ position: [0, 0, 5], fov: 50 }} dpr={[1, 2]}>
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} intensity={1} color="#ffffff" />
        <pointLight position={[-10, -10, -10]} intensity={0.5} color="#5ed29c" />
        <pointLight position={[10, -10, 10]} intensity={0.5} color="#4fd8ff" />
        <Sphere />
        <ContactShadows position={[0, -3, 0]} opacity={0.2} scale={8} blur={3} />
        <Environment preset="city" />
      </Canvas>
    </div>
  )
}